import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Mail } from 'lucide-react';
import { blogPosts } from '../mockData';
import { PageHero, SectionHeader, Reveal, TechCard, BtnPrimary } from '../components/ui-kit';

const Blog = () => {
  const [featured, ...rest] = blogPosts;
  return (
    <div className="min-h-screen" data-testid="blog-page">
      <PageHero
        testId="blog-hero"
        eyebrow="Actualités"
        title={<>Conseils, normes & <span className="text-energy-gradient">innovations</span></>}
        subtitle="Informations pratiques sur l'électricité, la plâtrerie et les évolutions réglementaires."
        image="/assets/projet21.jpg"
      />

      <section className="bg-[#F8FAFC] text-ink py-24 lg:py-32 circuit-grid-light" data-testid="blog-list">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <TechCard className="p-0 overflow-hidden group grid lg:grid-cols-2" data-testid={`blog-featured-${featured.id}`}>
              <div className="h-72 lg:h-auto overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-energy">À la une</span>
                <p className="mt-4 font-mono text-xs text-slate-500 inline-flex items-center gap-2"><Calendar size={13} /> {featured.date}</p>
                <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight group-hover:text-energy transition-colors">{featured.title}</h2>
                <p className="text-slate-600 mt-5 leading-relaxed">{featured.excerpt}</p>
                <span className="mt-8 inline-flex items-center gap-2 font-bold text-ink">Lire l'article <ArrowRight size={16} className="text-energy transition-transform group-hover:translate-x-1" /></span>
              </div>
            </TechCard>
          </Reveal>

          <div className="mt-8 grid md:grid-cols-2 gap-6">
            {rest.map((p, i) => (
              <Reveal key={p.id} delay={i * 100}>
                <TechCard className="h-full p-0 overflow-hidden group" data-testid={`blog-card-${p.id}`}>
                  <div className="h-56 overflow-hidden">
                    <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  </div>
                  <div className="p-7">
                    <p className="font-mono text-xs text-slate-500 inline-flex items-center gap-2"><Calendar size={13} /> {p.date}</p>
                    <h3 className="mt-3 font-display text-xl sm:text-2xl font-bold group-hover:text-energy transition-colors">{p.title}</h3>
                    <p className="text-sm text-slate-600 mt-3 leading-relaxed">{p.excerpt}</p>
                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-ink">Lire l'article <ArrowRight size={14} className="text-energy" /></span>
                  </div>
                </TechCard>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative bg-obsidian text-white py-20 overflow-hidden noise" data-testid="blog-newsletter">
        <div className="absolute inset-0 dot-matrix opacity-30" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <SectionHeader dark eyebrow="Une question technique ?" title="Nos experts vous répondent" subtitle="Normes NF C 15-100, isolation, domotique : posez-nous vos questions, nous vous conseillons gratuitement." />
          <Reveal delay={150}>
            <BtnPrimary to="/contact" data-testid="blog-contact-btn"><Mail size={18} /> Nous écrire</BtnPrimary>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Blog;
